import React, { useEffect, useState } from 'react';
import { X, Flame, AlertTriangle, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function EmailCapturePopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    if (hasShown) return;
    let triggered = false;
    const triggerOpen = () => {
      if (triggered) return;
      triggered = true;
      setIsOpen(true);
      setHasShown(true);
    };
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY < 10) triggerOpen();
    };
    const handleScroll = () => {
      const scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (scrolled > 0.5) triggerOpen();
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    window.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasShown]);
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const handleClaim = () => {
    setIsOpen(false);
    setTimeout(() => {
      const el = document.getElementById('offer');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm animate-in fade-in duration-200" onClick={() => setIsOpen(false)} role="dialog" aria-modal="true" data-id="element-198">
      <div className="bg-[#3E2723] rounded-2xl max-w-md w-full shadow-2xl relative overflow-hidden border-4 border-yellow-300" onClick={e => e.stopPropagation()} data-id="element-199">
        <button onClick={() => setIsOpen(false)} aria-label="Close" className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white z-10 transition-colors" data-id="element-200">
          <X className="w-4 h-4" data-id="element-201" />
        </button>

        <div className="bg-red-600 text-white text-center py-3 flex items-center justify-center gap-2 font-extrabold uppercase tracking-wider text-sm animate-pulse" data-id="element-202">
          <AlertTriangle className="w-5 h-5" data-id="element-203" />
          {t('exitPopup.wait')}
          <AlertTriangle className="w-5 h-5" data-id="element-204" />
        </div>

        <div className="p-8 text-center" data-id="element-205">
          <div className="w-16 h-16 mx-auto bg-red-600 rounded-full flex items-center justify-center mb-4 shadow-lg border-4 border-yellow-300" data-id="element-206">
            <Flame className="w-8 h-8 text-yellow-300" data-id="element-207" />
          </div>

          <h3 className="text-3xl text-white mb-3 leading-tight font-bold" data-id="element-208">
            {t('exitPopup.lose1')}
            <br data-id="element-209" />
            <span className="text-yellow-300" data-id="element-210">{t('exitPopup.lose2')}</span>
          </h3>

          <p className="text-white/80 mb-6 leading-relaxed" data-id="element-211">
            {t('exitPopup.desc1')}{' '}
            <strong className="text-yellow-300" data-id="element-212">{t('exitPopup.desc2')}</strong>{' '}
            {t('exitPopup.desc3')}{' '}
            <span className="text-white line-through font-bold" data-id="element-213">$12.90</span>.
          </p>

          <div className="bg-white/10 border border-yellow-300/30 rounded-lg p-4 mb-6" data-id="element-214">
            <div className="flex items-baseline justify-center gap-2" data-id="element-215">
              <span className="text-lg text-white/60 line-through" data-id="element-216">$12.90</span>
              <span className="text-4xl font-extrabold text-yellow-300" data-id="element-217">
                $6.39
              </span>
            </div>
            <div className="text-xs text-white/70 mt-1 uppercase tracking-wider font-bold" data-id="element-218">
              {t('exitPopup.limited')}
            </div>
          </div>

          <button onClick={handleClaim} className="w-full bg-[#C2410C] hover:bg-[#9A3412] text-white py-4 rounded-lg font-extrabold text-base uppercase tracking-wide transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-219">
            {t('exitPopup.claim')}
            <ArrowRight className="w-5 h-5" data-id="element-220" />
          </button>

          <button onClick={() => setIsOpen(false)} className="mt-3 text-white/50 hover:text-white/80 text-xs underline underline-offset-2 transition-colors" data-id="element-221">
            {t('exitPopup.noThanks')}
          </button>
        </div>
      </div>
    </div>;
}